import salesApi from '../../api/sales-api'
import router from '../../router'


const RESOURCE_NAME = '/app/sales';
const RESOURCE_NAME_PUBLIC = '/app/public/sales';

const sales = {
    items: [],
    item: {},
    listSelect: [],
    popupAssignSale: false,
    popupSeeSale: false,
    users: []
};

const mutations = {
    setItemsSale(state, payload) {
        state.items = payload.data;
    },
    setItemSale(state, payload) {
        state.item = payload;
    },
    setpopupAssignSale(state, payload) {
        state.popupAssignSale = payload;
    },
    setpopupSeeSale(state, payload) {
        state.popupSeeSale = payload;
    },
    setUsers(state, payload) {
        state.users = payload;
    },
};


const actions = {
    createSale({ commit, dispatch }, { sale, language }) {
        commit('loading', true);
        salesApi.create(sale, language).then(
            (response) => {
                commit('notifications', { title: 'sale.OfertaCreada' });
                commit('loading', false);
                router.push({ name: 'sales' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'sale.NotOfertaCreada', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    async refreshSales(context, { restaurant_id, language }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }
        context.commit('loading', true);
        const res = await salesApi.getAllByRestaurant(restaurant_id, language);
        context.commit('loading', false);

        context.commit('setItemsSale', res);
    },

    async getUsers() {
        const res = await salesApi.getUsers();
        context.commit('setUsers', res);
    },

    async getSale(context, { id, language }) {
        context.commit('setItemSale', {});
        const res = await salesApi.getSale(id, language);
        context.commit('setItemSale', res.data[0]);
    },

    editSale({ commit, dispatch }, { id, sale, language }) {
        commit('loading', true);
        salesApi.edit(id, sale, language).then(
            response => {
                dispatch('refreshSales', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'sale.EditSaleOk' });
                commit('loading', false);

                commit('showNotifications', true);
                router.push({ name: 'sales' });
            },
            error => {
                commit('notifications', { title: 'sale.EditSaleNotOk', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    async assignUser({ commit, dispatch }, { saleInfo, language }) {
        commit('loading', true);
        salesApi.assignUser(saleInfo, language).then(
            (response) => {
                commit('notifications', { title: 'fidelization.UserAssigned' });
                commit('loading', false);
                commit('showNotifications', true);
                commit('setpopupAssignSale', false);
            },
            (error) => {
                commit('notifications', { title: 'fidelization.UserAssignedError', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );

    },


    async getAll(restaurant_id, language) {
        if (!language) language = store.getters.getCurrentLanguage;
        const requestConfig = {
            headers: {
                // eslint-disable-next-line sonarjs/no-duplicate-string
                'Content-Type': 'multipart/form-data',
                'X-localization': language,
            },
        };
        const res = await salesApi.getAllByRestaurant(restaurant_id, language);
        context.commit('setItemsSale', res);
    },



    deleteSale({ commit, dispatch }, id) {
        commit('loading', true);
        salesApi.delete(id).then(
            (response) => {
                dispatch('refreshSales', {});
                commit('notifications', { title: 'sale.OfertaEliminada' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'sale.NotOfertaEliminada', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
};

const getters = {
    getSales: (state) => state.items,
    getSale: (state) => state.item,
    getpopupAssignSale: state => state.popupAssignSale,
    getpopupSeeSale: state => state.popupSeeSale
};

export default {
    state: sales,
    mutations,
    actions,
    getters,
};
